interface GlobalStateHost {
  globalState?: Record<string, unknown>;
}

export function globalState(): Record<string, unknown> {
  const host = globalThis as GlobalStateHost;
  host.globalState = host.globalState ?? {};
  return host.globalState;
}
